// extracted by mini-css-extract-plugin
module.exports = {"scroll-black":"auction_scroll-black__eO4PQ","auction-info-bid":"auction_auction-info-bid__nN7ty","checkbox-wrapper":"auction_checkbox-wrapper__Zp05S"};